const financePathPrefix = '/app/finance';
export const financePaths = {
  pathPrefix: financePathPrefix,
  pathPrefixHistory: `${financePathPrefix}/history`,
  balancePagePath: `${financePathPrefix}/balance`,
  holdWithdrawalPagePath: `${financePathPrefix}/holdWithdrawal`,
  termsAndProcedurePaymentsPagePath: `${financePathPrefix}/termsAndProcedurePayments`,
};
